module.exports = "https://beta.voredev.ru/assets/index/deal-f7ee53f92550db46eb601aea22a778d1.svg";